import styled from 'styled-components';

export const PercentBox = styled.div`
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: #00a8d8;
    box-shadow: 0 0 0 3px rgba(0, 184, 219, 0.16);
  }

  input {
    background: transparent;
    border: 0;
    font-weight: 700;
    font-size: 36px;
    line-height: 1;
    outline: none;
    text-align: right;
    height: auto;
    color: #0f172a;
    font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

    &::placeholder {
      color: #94a3b8;
      opacity: 1;
    }

    @media (max-width: 420px) {
      font-size: 30px;
    }
  }

  /* stylelint-disable property-no-vendor-prefix */
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PercentSym = styled.span`
  color: #475569;
  font-weight: 600;
  font-size: 36px;
  line-height: 1;

  @media (max-width: 420px) {
    font-size: 30px;
  }
`;
